import VideoData from '@/data/VideoData';
import Constants from '@/utils/Constants';
import Logger from '@/utils/Logger';
import VideoDataRelatedVideo from '../VideoDataRelatedVideo';

export default class VideoDataMapper {
  
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapFromVideoDataObj(videoDataObj: any) {

    if(!videoDataObj?.videoSources?.html?.auto?.length) {
      throw new Error(`Can not map ${videoDataObj} to VideoSource instance.`);
    }

    const videoSource = videoDataObj.videoSources.html.auto[0];
    
    if(videoSource.mimeType !== Constants.mimeTypeHls) {
      throw new Error(`Did not find required video source type ${Constants.mimeTypeHls} in ${videoDataObj}.`);
    }

    return new VideoData(videoSource.source);
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public static mapRelatedVideosFromVideoDataObj(videoData: any, playerId?: string) {
    
    if(!videoData?.relatedVideos || videoData.relatedVideos.length === undefined) {
      throw new Error(`Failed to map ${videoData} to array of VideoDataRelatedVideo instances.`);
    }

    const relatedVideos: Array<VideoDataRelatedVideo> = [];

    for(const relatedVideoObj of videoData.relatedVideos) {
      const videoId = relatedVideoObj.relatedVideoId;
      const duration = relatedVideoObj.duration;
      const thumbnailUrl = relatedVideoObj.thumbnailUrl;
      const title = relatedVideoObj.title;

      if(videoId && duration && thumbnailUrl && title) {
        relatedVideos.push(new VideoDataRelatedVideo(videoId, title, thumbnailUrl, duration, playerId));
      }
      else {
        Logger.warn(`Failed to map a related video, ${relatedVideoObj}.`);
      }
    }
    return relatedVideos;
  }

}